import "./App.css";

function App() {
  return (
    <main className="maintenance-page">
      <div className="maintenance-page__grain" aria-hidden="true" />
      <section className="maintenance-card" aria-labelledby="maintenance-title">
        <div className="maintenance-card__mark" aria-hidden="true">
          S
        </div>

        <div className="maintenance-card__content">
          <p className="maintenance-card__eyebrow">Sundar Foundation</p>
          <h1 id="maintenance-title">We’ll be back soon.</h1>
          <p className="maintenance-card__message">
            Our website is temporarily offline while we make a few updates.
            Thank you for your patience.
          </p>
          <div className="maintenance-card__status">
            <span className="maintenance-card__pulse" aria-hidden="true" />
            Temporary maintenance in progress
          </div>
        </div>

        <footer className="maintenance-card__footer">
          <span>Community. Care. Change.</span>
          <span aria-hidden="true">Est. 2024</span>
        </footer>
      </section>
    </main>
  );
}

export default App;
